// import { useState } from "react";
// import Barcode from "react-barcode";
import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import Barcode from "react-barcode";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { ApiLink } from "../APILink/ApiLink";
import axios from "axios";
import authHeader from "../Auth/authHeader";
import { errorAlert } from "../Components/Alerts";
import { Printer } from "lucide-react";
import Autocomplete from "@mui/material/Autocomplete";

const headers = authHeader();

const getCountryFromBarcode = (barcode) => {
  if (!barcode || barcode.length < 3) return { name: "Kosova", code: "xk" };
  const prefix = barcode.substring(0, 3);
  return prefix;
};

const BarcodeGeneratorModal = ({ open, handleClose, articleData }) => {
  const [barcode, setBarcode] = useState("");
  const [flagCode, setFlagCode] = useState("");
  const [countryName, setCountryName] = useState("");
  const printRef = useRef(null);

  const [articleOptions, setArticleOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const getFlagCode = (article) => {
    const prefix = getCountryFromBarcode(article?.barcode);

    if (prefix.length === 3 && /^\d+$/.test(prefix)) {
      fetchFlagCode(prefix);
    } else {
      setFlagCode("xk");
      setCountryName("Kosova");
    }
  };

  const fetchFlagCode = async (prefix) => {
    try {
      const response = await axios.get(ApiLink.API_URL + "Companies/FlagCode", {
        headers,
        params: { prefix: prefix },
      });
      setFlagCode(response.data[0].FlagCode);
      setCountryName(response.data[0].StateName);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Kthehet nga serveri për mungesë qasje
      } else {
        errorAlert("Gabim në kërkesë:", error);

        if (
          error.response &&
          error.response.data &&
          error.response.data.errorMessage
        ) {
          errorAlert(
            `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
          );
        } else if (error.message) {
          errorAlert(`Gabim: ${error.message}`);
        } else {
          errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
        }
      }
    }
  };

  const fetchArticleSalesOptions = async (articleId) => {
    try {
      // Thirrja e endpoint-it të ri në controller
      const response = await axios.get(
        `${ApiLink.API_URL}Article/sales-options/${articleId}`,
        { headers },
      );

      // Ruajtja e të dhënave në state (supozojmë se ke një state për listën)
      setArticleOptions(response.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Mesazhi kur nuk gjendet asnjë opsion për atë ID
        errorAlert("Nuk u gjet asnjë opsion shitjeje për këtë artikull.");
      } else {
        // Logjika jote ekzistuese për gabimet
        if (
          error.response &&
          error.response.data &&
          error.response.data.errorMessage
        ) {
          errorAlert(`Gabim: ${error.response.data.errorMessage}`);
        } else {
          errorAlert("Gabim gjatë marrjes së opsioneve të artikullit.");
        }
      }
    }
  };

  // const handleGenerate = () => {
  //     const detectedCountry = getCountryFromBarcode(barcode);
  //     setCountry(detectedCountry);
  // };

  const closeModal = () => {
    handleClose();
    setFlagCode("");
    setCountryName("");
  };

  const handlePrint = () => {
    const table = printRef.current;

    if (!table) {
      console.error("Table reference not found.");
      return;
    }

    const printWindow = window.open("", "PrintWindow", "height=400,width=600");

    if (!printWindow) {
      console.error("Print window could not be opened.");
      return;
    }

    printWindow.document.open();
    printWindow.document.write(`
            <html>
            <head>
                <title>Print Table Data</title> <!-- Titulli i dritares -->
                <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    table, th, td {
                        border: 1px solid black;
                    }
                    th, td {
                        padding: 8px;
                        text-align: left;
                    }
                </style>
            </head>
            <body>
                ${table.outerHTML}
            </body>
            </html>
        `);

    printWindow.document.title = "print";
    printWindow.document.close();

    printWindow.focus();
    printWindow.print();

    printWindow.close();
  };

  // const handlePrint = useReactToPrint({
  //     content: () => printRef.current, // Referenca e div-it që do të printohet
  //     documentTitle: "Barcode Print", // Opsionale: Vendos një titull të dokumentit
  //     onAfterPrint: () => console.log("Printing completed!"), // Opsionale: Callback pas printimit
  // });
  // const print = useReactToPrint({
  //     content: () => printRef.current,
  // });

  // const handlePrint = () => {
  //     for (let i = 0; i < copies; i++) {
  //         setTimeout(() => {
  //             print();
  //             console.log(`Printimi ${i}`);
  //         }, i * 500);
  //     }
  // };

  //    const handleAutocompleteArticleOptions = (event, value) => {
  //     if (value) {
  //         // setFormData((prevState) => ({
  //         //     ...prevState,
  //         //     LedgerID: value.LedgerID,
  //         // }));
  //     } else {
  //         // setFormData((prevState) => ({
  //         //     ...prevState,
  //         //     LedgerID: "",
  //         // }));
  //     }
  // };

  // const defaultPropsArticleOptions = {
  //     options: article,
  //     getOptionLabel: (option) =>
  //         `${option.LedgerNameEN}` || "",
  //     renderOption: (props, option) => (
  //         <>
  //             <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //                 <span>
  //                     <b> {option.LedgerNameEN}</b><br />
  //                 </span>
  //             </li>
  //         </>
  //     ),
  // };
  //   const handleAutocompleteArticleOptions = (event, value) => {
  //     if (value) {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         Barcode: value.NewBarcode,
  //         ArticleSalesOptionsID: value.ArticleSalesOptionsID,
  //         SalesPrice: value.NewSalesPrice,
  //       }));
  //     } else {
  //       // Opsionale: Çfarë ndodh nëse e bën "Clear" (X)
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         Barcode: "",
  //         ArticleSalesOptionsID: null,
  //         SalesPrice: 0,
  //       }));
  //     }
  //   };
  const defaultPropsArticleOptions = {
    options: articleOptions,
    getOptionLabel: (option) =>
      option ? `${option.NewBarcode} - ${articleData?.ArticleName}` : "",
    renderOption: (props, option) => (
      <li
        {...props}
        key={option.ArticleSalesOptionsID}
        style={{ borderBottom: "1px solid lightgray" }}
      >
        <span>
          <b>{option.NewBarcode}</b> - {articleData?.ArticleName} - Çmimi: {option.NewSalesPrice}€
        </span>
      </li>
    ),
  };

  useEffect(() => {
    // Ekzekutohet vetëm nëse modali është i hapur DHE kemi të dhëna për artikullin
    if (open && articleData?.rowInfo?.ArticleID) {
      setBarcode(articleData?.Barcode || "");
      getFlagCode(articleData);
      fetchArticleSalesOptions(articleData.rowInfo.ArticleID);
    }
  }, [open, articleData]); // Shto 'open' te dependency array

  useEffect(() => {
    if (articleOptions && articleOptions.length > 0) {
      // Automatikisht zgjedhim rreshtin e parë që vjen nga SQL (i cili është i renditur me ASC)
      setSelectedOption(articleOptions[0]);
    } else {
      setSelectedOption(null);
    }
  }, [articleOptions]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Barkodi i artikullit:</DialogTitle>
      {/* <DialogContent style={{ padding: "10px" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                        label="Artikulli"
                        fullWidth
                        value={`${barcode}-${articleData?.ArticleName}`}
                        onChange={(e) => setBarcode(e.target.value)}
                    />
                </div>
                <hr></hr>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                    <div ref={printRef}>
                        <div style={{ width: "2.29in", height: "1in", border: "solid red 1px", textAlign: "center" }}>
                            <div>
                                <label style={{ fontSize: "12px" }}>{articleData?.ArticleName ? (articleData.ArticleName.length > 30 ? articleData.ArticleName.slice(0, 30) : articleData.ArticleName) : "Emri Artikullit"}</label>
                            </div>
                            <div style={{ display: "flex", height: "0.5in", marginTop: "-5px" }}>
                                <div>
                                    {barcode ? <Barcode value={barcode} width={1} height={15} fontSize={15} /> : <p>Barcode not available</p>}
                                </div>
                                <div>
                                    {countryName && (
                                        <>
                                            <img
                                                src={`/flags/${flagCode}.png`}
                                                alt={`${countryName} Flag`}
                                                width="50"
                                                style={{ paddingTop: "10px" }}
                                            />
                                            <p style={{ fontSize: "12px" }}>{countryName}</p>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div>
                                <p>{articleData?.SalesPrice || "0.00"} €</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Button onClick={handlePrint} color="primary" variant="contained">
                            Shtyp Tiketën
                        </Button>
                    </div>
                </div>
            </DialogContent> */}
      <DialogContent style={{ padding: "20px", background: "#f8fafc" }}>
        <div style={{ marginBottom: "20px" }}>
          {/* <TextField
            label="Artikulli"
            fullWidth
            value={`${barcode}-${articleData?.ArticleName}`}
            onChange={(e) => setBarcode(e.target.value)}
          /> */}
          <Autocomplete
            {...defaultPropsArticleOptions}
            fullWidth
            id="ArticleOptionsSelect"
            // 'value' tregon se cili rresht është i selektuar vizualisht
            value={selectedOption}
            onChange={(event, newValue) => {
              setSelectedOption(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Zgjidh Opsionin e Shitjes" />
            )}
          />
        </div>

        <div
          style={{
            position: "relative",
            marginTop: "20px",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: "-4px",
              background: "linear-gradient(to right,#fee2e2,#fef2f2)",
              borderRadius: "16px",
              filter: "blur(6px)",
              opacity: 0.5,
            }}
          />

          <div
            ref={printRef}
            style={{
              position: "relative",
              background: "white",
              border: "2px solid #f1f5f9",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
              overflow: "hidden",
              width: "260px",
              margin: "auto",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "6px",
                width: "100%",
                background: "#ef4444",
              }}
            />

            <h3
              style={{
                fontSize: "18px",
                fontWeight: "700",
                color: "#0f172a",
                textTransform: "uppercase",
                marginBottom: "20px",
                textAlign: "center",
              }}
            >
              {articleData?.ArticleName
                ? articleData.ArticleName.length > 30
                  ? articleData.ArticleName.slice(0, 30)
                  : articleData.ArticleName
                : "Emri Artikullit"}
            </h3>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {barcode ? (
                  <Barcode
                    // value={barcode}
                    value={selectedOption ? selectedOption.NewBarcode : ""}
                    width={1}
                    height={40}
                    fontSize={14}
                  />
                ) : (
                  <p>Barcode not available</p>
                )}

                {/* <span
                  style={{
                    fontFamily: "monospace",
                    fontSize: "12px",
                    color: "#64748b",
                    letterSpacing: "2px",
                  }}
                >
                  {selectedOption ? selectedOption.NewBarcode : ""}
                </span> */}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                {countryName && (
                  <>
                    <img
                      src={`/flags/${flagCode}.png`}
                      alt={`${countryName} Flag`}
                      width="40"
                      style={{ marginBottom: "5px" }}
                    />
                    <span style={{ fontSize: "12px", color: "#64748b" }}>
                      {countryName}
                    </span>
                  </>
                )}

                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "4px",
                    marginTop: "5px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "32px",
                      fontWeight: "800",
                      color: "#0f172a",
                    }}
                  >
                    {/* {articleData?.SalesPrice || "0.00"} */}
                      {selectedOption ? selectedOption.NewSalesPrice : 0}

                  </span>

                  <span
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#475569",
                    }}
                  >
                    €
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <button
          style={{
            width: "100%",
            borderRadius: "12px",
            padding: "14px",
            fontWeight: 600,
            cursor: "pointer",
            background: "#2563eb",
            color: "white",
            border: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Printer size={20} />
          SHTYP TIKETËN
        </button> */}
        {/* <button
          onClick={closeModal}
          color="secondary"
          style={{
            width: "100%",
            borderRadius: "12px",
            padding: "14px",
            fontWeight: 600,
            cursor: "pointer",
            background: "transparent",
            color: "#64748b",
            border: "none",
          }}
        >
          MBYLL
        </button> */}
        {/* <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handlePrint}
            variant="contained"
            style={{
              background: "#2563eb",
              padding: "10px 20px",
              borderRadius: "10px",
            }}
          >
            Shtyp Tiketën
          </Button>
        </div> */}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handlePrint}
          variant="contained"
          style={{ width: "100%" }}
        >
          <Printer size={20} />
          SHTYP TIKETËN
        </Button>
        <Button
          onClick={closeModal}
          color="secondary"
          style={{ width: "100%" }}
        >
          Mbyll
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BarcodeGeneratorModal;
